export default __webpack_public_path__ + "static/media/8.4587f0b9.png";